/* Generic driver for kkumi-accordion-item snippets. Only containers that
   opt in with data-kk-accordion are handled — sections with their own
   accordion logic (kkumi-faq-main) leave the attribute off but reuse
   window.kkumiAccSetOpen so every FAQ animates identically.

   Why measured heights: transitioning max-height to a fixed cap (the old
   600px) animates the full cap distance regardless of content height —
   opens overshoot and closes sit in dead time before anything moves.
   Animating to the panel's real scrollHeight keeps the perceived speed
   constant, then max-height is released to 'none' so open panels can
   reflow naturally. */
(function () {
  /* Toggles an accordion item with a measured-height animation.
     Owns the is-open class flip: the inline pin to the panel's current
     rendered height MUST land before the class changes, otherwise the
     CSS fallback (.is-open -> max-height: none) expands the panel in
     the same style pass and the transition has nothing to animate. */
  function setOpen(item, panel, open) {
    if (!panel) {
      if (item) item.classList.toggle('is-open', open);
      return;
    }
    if (panel._kkAccEnd) {
      panel.removeEventListener('transitionend', panel._kkAccEnd);
      panel._kkAccEnd = null;
    }
    var current = panel.getBoundingClientRect().height;
    panel.style.maxHeight = current + 'px';
    if (item) item.classList.toggle('is-open', open);
    void panel.offsetHeight;
    if (open) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      var onEnd = function (e) {
        if (e.target !== panel || e.propertyName !== 'max-height') return;
        panel.style.maxHeight = 'none';
        panel.removeEventListener('transitionend', onEnd);
        panel._kkAccEnd = null;
      };
      panel._kkAccEnd = onEnd;
      panel.addEventListener('transitionend', onEnd);
    } else {
      panel.style.maxHeight = '0px';
    }
  }
  window.kkumiAccSetOpen = setOpen;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kk-acc__q');
    if (!btn || !btn.closest('[data-kk-accordion]')) return;
    var item = btn.closest('.kk-acc');
    if (!item) return;
    var open = !item.classList.contains('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    setOpen(item, item.querySelector('.kk-acc__a'), open);
  });

  /* Deep links: /pages/x#<item id> opens that item and brings it into view, on load and when the hash
     changes (Support links replies to answers this way). Only items inside a [data-kk-accordion] list:
     a section with its own accordion logic (kkumi-faq-main) handles its own links. A hash that names
     nothing here does nothing. */
  function openFromHash(smooth) {
    var id = '';
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return; }
    var item = id ? document.getElementById(id) : null;
    if (!item || item.hidden || !item.classList.contains('kk-acc') || !item.closest('[data-kk-accordion]')) return;
    var btn = item.querySelector('.kk-acc__q');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (!item.classList.contains('is-open')) setOpen(item, item.querySelector('.kk-acc__a'), true);
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    item.scrollIntoView({ behavior: smooth && !calm ? 'smooth' : 'auto', block: 'start' });
  }
  openFromHash(false);
  window.addEventListener('hashchange', function () { openFromHash(true); });
})();
